import { useQuery } from "@tanstack/react-query";
import { GET_CALCULATE_SHIPMENT_DATA } from "@/constants/Query";
import { apiRequest } from "@/utils/apiRequest";
import { IShipmentPrice } from "@/types/apiResponse.types";

export const useGetCalculateShipmentRequest = () => {
  return useQuery<{
    data: {
      data: IShipmentPrice;
    };
  }>({
    queryKey: [GET_CALCULATE_SHIPMENT_DATA],
    queryFn: () => apiRequest(GET_CALCULATE_SHIPMENT_DATA, "get"),
  });
};
